import { useState, useEffect } from "react";

const includesIgnoreCase = (value, search) =>
  String(value).toLowerCase().includes(search.toLowerCase());

const normalizeSheet = (sheet) => {
  if (!sheet?.obj) return null;

  return {
    id: sheet.obj.sheet_id || "",
    name: sheet.obj.sheet_name || "Brak nazwy",
    types: sheet.obj.sheet_types || [],
    exam_month: sheet.obj.exam_month || "",
    year: sheet.obj.year || "",
    answer_key: sheet.obj.answer_key || "",
    answer_key_url: sheet.obj.answer_key_url || "",
    attachment_url: sheet.obj.attachment_url || "",
    groups_completed: sheet.obj.groups_completed || {},
    raw: sheet.obj
  };
};

export const useSheets = (initialSheets) => {

  const [sheets, setSheets] = useState([]);

  const [search, setSearch] = useState("");
  // const debouncedSearch = useDebounce(search, 100);
  const [yearFilter, setYearFilter] = useState("");
  const [sessionFilter, setSessionFilter] = useState("");
  const [groupFilter, setGroupFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  useEffect(() => {
    if (!initialSheets) return;

    setSheets(prev => {
      const normalized = (initialSheets || [])
        .map(normalizeSheet)
        .filter(Boolean);

      // 🔥 tylko jeśli dane się zmieniły
      if (JSON.stringify(prev) === JSON.stringify(normalized)) {
        return prev;
      }

      return normalized;
    });

  }, [initialSheets]);
  
  const filteredSheets = sheets.filter(sheet => {

    // 1️⃣ SEARCH
    const normalizedSearch = search.trim().toLowerCase();

    const matchesSearch =
      !normalizedSearch ||
      includesIgnoreCase(sheet.name, normalizedSearch) ||
      includesIgnoreCase(sheet.id, normalizedSearch) ||
      (sheet.types || []).some(t => {
        const sheetType = String(t.sheet_type || "").toLowerCase();

        return (
          sheetType === normalizedSearch ||
          (
            normalizedSearch.length > 2 &&
            includesIgnoreCase(t.short_description, normalizedSearch)
          )
        );
      });
    // ---------- YEAR FILTER ----------
    const matchesYear =
      !yearFilter ||
      String(sheet.year) === String(yearFilter);

    // ---------- SESSION FILTER ----------
    const matchesSession =
      !sessionFilter ||
      String(sheet.exam_month) === String(sessionFilter);

    // ---------- STATUS FILTER ----------
    // 2️⃣ STATUS (w kontekście grupy)
    let matchesStatus = true;

    if (groupFilter && statusFilter !== "all") {

      const groupsCompleted = Object.values(sheet.groups_completed || {});

      const isCompletedForGroup = groupsCompleted.some(
        g => g.group_symbol === groupFilter
      );

      if (statusFilter === "completed") {
        matchesStatus = isCompletedForGroup;
      }

      if (statusFilter === "not_completed") {
        matchesStatus = !isCompletedForGroup;
      }
    }
    return matchesSearch && matchesYear && matchesSession && matchesStatus;
  });
  return {
    sheets: filteredSheets,
    search,
    setSearch,
    yearFilter,
    setYearFilter,
    sessionFilter,
    setSessionFilter,
    groupFilter,
    setGroupFilter,
    statusFilter,
    setStatusFilter,
    setSheets
  };
};